export default {
  baseStyle: {
    boxShadow: 'none',
    _focus: {
      boxShadow: 'none',
      outline: 'none'
    },
    _active: {
      boxShadow: 'none',
      outline: 'none'
    }
  }
}
